<template>
  <div class="page login-page">
    <video class="bg-video" autoplay loop muted playsinline>
      <source src="/img/login/4.mp4" type="video/mp4" />
    </video>
    <div class="login-content">
      <van-nav-bar class="nav-bar" :title="$t('auth.login')" :border="false" placeholder>
        <template #right>
          <div class="language-selector" @click.stop="languageOpen = !languageOpen">
            <span class="current-flag">{{ currentLanguage.flag }}</span>
            <span class="current-code">{{ currentLanguage.code.toUpperCase() }}</span>
            <van-icon :name="languageOpen ? 'arrow-up' : 'arrow-down'" size="14" color="#fff" />
            <div v-if="languageOpen" class="language-dropdown" @click.stop>
              <div v-for="item in languageOptions" :key="item.code" class="language-option"
                :class="{ active: $i18n.locale === item.code }" @click="changeLang(item.code)">
                <span class="language-flag">{{ item.flag }}</span>
                <span class="language-name">{{ item.name }}</span>
                <span v-if="$i18n.locale === item.code" class="language-check">✓</span>
              </div>
            </div>
          </div>
        </template>
      </van-nav-bar>

      <div class="form-wrap">
        <div class="form-title">{{ $t("auth.login") }}</div>

        <div class="form-fields">
          <van-field v-model="username" clearable class="input-large" input-align="center"
            :placeholder="$t('auth.username_place')" />
            
          <van-field v-model="password" :type="passwordType" class="input-large" input-align="center"
            :placeholder="$t('auth.pwd_place')">
            <template #right-icon>
              <van-icon :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                @click="switchPasswordType" />
            </template>
          </van-field>

          <van-button class="btn-large-primary" :loading="isSubmitting" @click="doLogin()">
            {{ $t("auth.login") }}
          </van-button>

          <div @click="toRegister()" class="register-text">
            <span>{{ $t("auth.no_account") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      passwordType: "password",
      isSubmitting: false,
      languageOpen: false,
      languageOptions: [
        { code: 'en', flag: '🇺🇸', name: 'English' },
        { code: 'zh', flag: '🇨🇳', name: '中文' },
        { code: 'ja', flag: '🇯🇵', name: '日本語' },
        { code: 'kr', flag: '🇰🇷', name: '한국어' }
      ],
    };
  },
  computed: {
    currentLanguage() {
      return this.languageOptions.find(item => item.code === this.$i18n.locale) || this.languageOptions[0];
    }
  },
  methods: {
    changeLang(lang) {
      this.languageOpen = false;
      localStorage.setItem('lang', lang);
      this.$i18n.locale = lang;
      this.$http({ method: 'get', url: 'replaceLang', data: { lang: lang } });
    },
    switchPasswordType() {
      this.passwordType = this.passwordType === "password" ? "text" : "password";
    },
    back() {
      this.$router.back();
    },
    toRegister() {
      this.$router.push("/Register");
    },
    doLogin() {
      if (!this.username) return this.$toast(this.$t("auth.username_place"));
      if (!this.password) return this.$toast(this.$t("auth.pwd_place"));
      this.isSubmitting = true;
      this.$http({
        url: "member_login",
        method: "get",
        data: {
          username: this.username,
          password: this.password
        },
      }).then((res) => {
        this.isSubmitting = false;
        if (res.code === 200) {
          localStorage.setItem("token", res.data.id);
          this.$router.push("Home");
        } else {
          this.$toast(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
  .login-page {
    position: relative;
    min-height: 100vh;
    overflow: hidden;
    /* 防止视频溢出 */
  }

  /* 视频全屏背景样式 */
  .bg-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }

  .login-content {
    position: relative;
    /* 确保表单层级高于视频 */
    z-index: 1;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .nav-bar {
    background: transparent !important;

    ::v-deep .van-nav-bar__content {
      height: 60px;
    }
  }


  .language-selector {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 100%;
    cursor: pointer;
  }

  .current-flag { font-size: 24px; line-height: 1; }
  .current-code { color: #fff; font-size: 22px; font-weight: 700; }

  .language-dropdown {
    position: absolute;
    top: 46px;
    right: 0;
    z-index: 2000;
    width: 270px;
    max-height: 390px;
    overflow-y: auto;
    padding: 8px 0;
    border: 1px solid #dedede;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 10px 28px rgba(0, 0, 0, .28);
    color: #34313b;
  }

  .language-option {
    display: flex;
    align-items: center;
    min-height: 58px;
    padding: 0 18px;
    font-size: 24px;
    white-space: nowrap;
  }

  .language-option:active,
  .language-option.active { background: #f3efff; color: #6f55d9; }
  .language-flag { width: 40px; margin-right: 12px; font-size: 27px; line-height: 1; }
  .language-name { flex: 1; text-align: left; }
  .language-check { margin-left: 14px; color: #6f55d9; font-weight: 700; }
  .language-dropdown::-webkit-scrollbar { width: 7px; }
  .language-dropdown::-webkit-scrollbar-thumb { border-radius: 8px; background: #aaa; }

  .form-wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 22vh 24px 0;
  }

  .form-title {
    font-size: 34px;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    margin-bottom: 24px;
    letter-spacing: 1px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  }

  .form-fields {
    width: 100%;
    max-width: 440px;
    margin: 0 auto;
  }

  .input-large {
    background: rgba(45, 45, 60, 0.75) !important;
    border-radius: 60px;
    margin-bottom: 24px;
    min-height: 66px;
    padding: 20px 28px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    ::v-deep .van-field__control {
      font-size: 32px;
      line-height: 26px;
      color: #ffffff;
    }

    ::v-deep .van-field__control::placeholder {
      color: #a0a0ab;
    }

    ::v-deep .van-field__right-icon {
      position: absolute;
      right: 24px;

      .van-icon {
        font-size: 32px;
        color: #7d7d9f;
      }
    }
  }

  .btn-large-primary {
    width: 100%;
    height: 62px;
    border-radius: 60px;
    background: #5b6cf2;
    color: #ffffff;
    border: none;
    font-size: 32px;
    font-weight: 600;
    margin: 16px 0;
    box-shadow: 0 4px 15px rgba(91, 108, 242, 0.4);
    transition: all 0.3s ease;

    &:active {
      opacity: 0.85;
      transform: scale(0.98);
    }

  }

  .register-text {
    text-align: center;
    margin-top: 14px;
    padding: 15px 20px;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0.55);
    border-radius: 60px;
    background: rgba(20, 20, 38, 0.48);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
    transition: all 0.25s ease;

    span {
      color: #ffffff;
      font-size: 30px;
      font-weight: 600;
      letter-spacing: 0.5px;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.6);
      opacity: 0.85;
    }

    &:hover span, &:active span { opacity: 1; }
    &:hover { border-color: #fff; background: rgba(91, 108, 242, 0.36); }
    &:active { transform: scale(0.98); background: rgba(91, 108, 242, 0.5); }
  }

  .form-links-center,
  .form-links-bottom {
    text-align: center;
  }

  .link-item {
    color: #ffffff;
    font-size: 32px;
    cursor: pointer;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  }

</style>
